import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const OTAViewModule = new Module({
  id: 'OTA:VIEW:RESULT-TABLE',
  name: 'OTA',
  label: 'OTA',
  path: 'ota',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/OTA/View'))
  ),
  actions: {
    details: {
      id: 'OTA:VIEW:OTA-DETAILS',
      name: 'details',
      label: 'View Details'
    },
    abort: {
      id: 'OTA:ABORT:RESULT-TABLE',
      name: 'abort',
      label: 'Abort'
    },
    abortJob: {
      id: 'OTA:ABORT:OTA-JOB',
      name: 'abortJob',
      label: 'Abort Job'
    },
    checkDevicesStatus: {
      id: 'OTA:VIEW:CHECK-DEVICES-STATUS',
      name: 'checkDevicesStatus',
      label: 'Check Devices Status'
    },
  }
});

export const OTAAddModule = new Module({
  id: 'OTA:CREATE:OTA-FORM',
  name: 'otaAdd',
  path: 'ota/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/OTA/Form'))
  ),
  actions: {
    add: {
      id: 'OTA:CREATE:OTA-FORM',
      name: 'OTA Add',
      label: 'Add OTA'
    }
  }
});


const OTAModules = [OTAViewModule, OTAAddModule];

export default new ModuleBundle('OTA', OTAModules);
